import TopSlider from './top-slider';
export default TopSlider;